export enum ErrorCodes {
  crash = '424',
  invalid = '422',
}
